import { Country } from '../../models/country';

export abstract class ICountryService {
    abstract GetAllCountries(): Country[];

    abstract RequireAddress(c: string): boolean;
}
